export function buildQuery(params) {
    const search = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
        if (value === null || value === undefined || value === '')
            continue;
        search.set(key, String(value));
    }
    const encoded = search.toString();
    return encoded ? `?${encoded}` : '';
}
/** `withQuery('/reporting/visits', { from, to, regionId })`. */
export function withQuery(path, params) {
    return `${path}${buildQuery(params)}`;
}
//# sourceMappingURL=query.js.map